import React, { useEffect, useState } from "react";
import CustomTable from "@components/CustomTable";
import myStore from "./store";
import { Observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import Confirmationpopup from "@components/ConfirmationPopup";

import FileDropModal from "./FileDropModal";
import { getColumnsConfig } from "./columns";
import {
  getActionsConfig,
  createFileDropAction,
  handleFileDrop,
} from "./actions";
import {
  DEFAULT_MONTH_RANGE,
  TRIM_CURRENT_DATE,
  FIRST_INDEX,
  PINNING_INITIAL_STATE,
  MAX_TABLE_HEIGHT,
  PINNED_ROW_HEIGHT,
  FILTER_DISPLAY_VALUES,
  SELECTED_FILTERS_DISPLAY,
  FILTERS,
  SHOW_FILTER,
} from "./constants";

const DataAcquisitions = () => {
  const { t: translate, i18n } = useTranslation();

  const [currentDateTime, setCurrentDateTime] = useState("");
  const [openConfirmationModal, setOpenConfirmation] = useState(null);
  const [currentDataAcquisitionId, setCurrentDataAcquisitionId] =
    useState(null);
  const [openFileDropModal, setOpenFileDropModal] = useState(false);

  // Initialize actions config
  const baseActions = getActionsConfig(myStore, translate);

  // Create FILE_DROP action with modal handler
  const fileDropAction = createFileDropAction(
    setOpenFileDropModal,
    setCurrentDataAcquisitionId,
    myStore,
    translate
  );

  // Merge actions with FILE_DROP override
  const actions = {
    ...baseActions,
    FILE_DROP: fileDropAction,
  };

  // Get columns with actions
  const columns = getColumnsConfig(setOpenConfirmation, actions, translate);

  useEffect(() => {
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - DEFAULT_MONTH_RANGE);

    const formattedDateTime = today
      .toISOString()
      .slice(FIRST_INDEX, TRIM_CURRENT_DATE);
    setCurrentDateTime(formattedDateTime);
  }, []);

  const multipleValueColumns = columns
    .filter((column) => column.isMultiple)
    .map((column) => column.accessorKey);

  const handleFileDropProceed = (files, onReset) => {
    setOpenConfirmation({
      ...actions["FILE_DROP"],
      actionFN: () => {
        handleFileDrop(currentDataAcquisitionId, files, myStore);
      },
      cancelAction: onReset,
      confirmationMessage: (
        <div className="flex text-left flex-col">
          <span>{translate("data-acquisitions.file-upload")}</span>
          <ul className="text-sm overflow-x-hidden list-inside list-disc flex flex-col gap-2 dark:text-primary-400 text-primary-700 mt-2">
            {files.map((file) => (
              <li key={file.name} className="gap-2 list-item">
                <span>{file.name}</span>
              </li>
            ))}
          </ul>
        </div>
      ),
    });
  };

  return (
    <Observer>
      {() => {
        return (
          <>
            <CustomTable
              store={myStore}
              columnsWithoutPin={columns}
              loading={myStore.loading}
              pinCondition={(row) => {
                return false;
              }}
              filterDisplayValues={FILTER_DISPLAY_VALUES}
              selectedFiltersDisplay={SELECTED_FILTERS_DISPLAY}
              filters={FILTERS}
              pinningInitialState={PINNING_INITIAL_STATE}
              setParentSelectedValues={() => {}}
              actions={actions}
              prefix="DataAcquisitions"
              title={translate("data-acquisitions.title")}
              multipleValueColumns={multipleValueColumns}
              pinnedRowHeight={PINNED_ROW_HEIGHT}
              maxTableHeight={MAX_TABLE_HEIGHT}
              showFilter={SHOW_FILTER}
              headerHeight={35}
              language={i18n.language}
              hideActionOnRow={(row) => {
                const statusTag = row.original.DataAcquisitionStatusTag;
                return statusTag === "DISABLED";
              }}
            />
            {openFileDropModal && (
              <FileDropModal
                isOpen={openFileDropModal}
                onClose={() => setOpenFileDropModal(false)}
                onProceed={handleFileDropProceed}
                currentDataAcquisitionId={currentDataAcquisitionId}
              />
            )}
            {openConfirmationModal && (
              <Confirmationpopup
                singleAction={openConfirmationModal}
                setOpenConfirmationAction={setOpenConfirmation}
              />
            )}
          </>
        );
      }}
    </Observer>
  );
};

export default DataAcquisitions;
